var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.path)?_c('svg-vue',{class:'svg-inline--fa fa-' + (this.size ? this.size : '1x'),attrs:{"icon":this.path}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }